import React, { useContext } from 'react';

import { DrawerComponent } from 'components/Drawer';
import * as S from './styles';
import { FeatureContext } from 'contexts/FeaturesContext';

interface IDataAgency {
  closeDrawer: () => void;
  onClose?: () => void;
}
const formatAddress = (address: any): string => {
  const parts: string[] = [];

  if (address.name) parts.push(address.name);
  if (address.number) parts.push(address.number);
  if (address.district) parts.push(address.district);
  if (address.city) parts.push(address.city);
  if (address.state) parts.push(address.state);
  // if (address.zipcode) parts.push(address.zipcode);

  return parts.join(', ').replace(/,([^,]*)$/, ' -$1');
};
const DataAgency = ({ closeDrawer }: IDataAgency) => {
  // const accessToken = localStorage.getItem('accessToken');
  // const idToken = localStorage.getItem('idToken');
  const { dataAgency } = useContext(FeatureContext);
  return (
    <>
      <DrawerComponent
        open
        size="default"
        // className={styles.drawer}
        onCompleteClose={closeDrawer}
        titleClose={'Dados da imobiliária'}
      >
        <S.Title>{dataAgency?.name}</S.Title>
        <S.WrapperInvoiceDetail>
          <div>
            <S.SubTitle>Endereço</S.SubTitle>
            <p>{formatAddress(dataAgency?.address)}</p>
          </div>
        </S.WrapperInvoiceDetail>
        <S.WrapperInvoiceDetail>
          <S.Grid>
            <div style={{ width: '260px' }}>
              <S.SubTitle>CNPJ</S.SubTitle>
              <p> {dataAgency?.cpfcnpj}</p>
            </div>
            <div>
              <S.SubTitle>CRECI</S.SubTitle>
              <p> {dataAgency?.creci || 'Não informado'}</p>
            </div>
          </S.Grid>
        </S.WrapperInvoiceDetail>
        <hr style={{ margin: '0 16px' }} />
        <S.WrapperInvoiceDetail>
          <div style={{ width: '50%' }}>
            <S.SubTitle>Telefone</S.SubTitle>
            <p style={{ color: !dataAgency?.phone ? '#808080' : undefined }}>
              {' '}
              {dataAgency?.phone || 'Não informado'}
            </p>
          </div>
        </S.WrapperInvoiceDetail>
        {dataAgency?.arrEmail.map((el, index) => (
          <S.WrapperInvoiceDetail key={index}>
            <div>
              <S.SubTitle>
                E-mail de cobrança{' '}
                {dataAgency?.arrEmail.length > 1 && index + 1}
              </S.SubTitle>

              <p> {el}</p>
            </div>
          </S.WrapperInvoiceDetail>
        ))}
      </DrawerComponent>
    </>
  );
};
export default DataAgency;
